import moment = require("moment");
import * as React from "react";
// tslint:disable-next-line:no-implicit-dependencies
import {Subscription} from "rxjs";
import {I18n} from "../../../../components/Utils/i18n";
import {Haccp, HaccpLocationSingleElement, HaccpPagePopupController} from "../Haccp";
import {
    ceilFixed,
    DEFAULT_OTHER_PRODUCT_CATEGORY_GUID,
    DEFAULT_TEMPERATURE_UNIT,
    DEFAULT_TIME_UNIT,
    EquipmentModel,
    HaccpConfiguration,
    HaccpController, numberOfDays,
} from "../HaccpController";
import {HaccpService} from "../HaccpService";
import {HaccpTableRow} from "./HaccpTableRow";
import {ConfigurationPopup} from "./popups/ConfigurationPopup";
import {ConfirmationPopup} from "./popups/ConfirmationPopup";

import {HaccpEquipmentRow} from "./HaccpEquipmentRow";
import "./HaccpTable.scss";

declare var LOCALE: string;

enum PopupAction {
    CREATE,
    EDIT,
}

export interface PossibleContent {
    guid: string;
    maxTemperature: number;
    minTemperature: number;
    name: string;
}

export interface ConfigurationPopupInitData {
    name: string;
    guid: string;
    currentMax?: number;
    currentMin?: number;
    productCategory?: any;
    modelGuid: string;
}

export interface HaccpTableProps {
    controller: HaccpController;
    configuration: HaccpConfiguration[];
    notConfigured: any[];
    numberRecords: number;
    equipmentModel: EquipmentModel;
    texts: {
        diagnostics: string,
        low: string,
        high: string,
        editPopupTitle: string,
        createPopupTitle: string,
        editConfirmationButton: string,
        createConfirmationButton: string,
        editPopupContent: string,
        createPopupContent: string,
        configurationPopup: {
            cancelButtonText: string,
            maxLabel: string,
            minLabel: string,
            contentTypeLabel: string,
            thresholdLabel: string,
            warning: string,
            popupMinThresholdError: string,
            popupMaxThresholdError: string,
        };
        row: {
            max: string,
            avg: string,
            min: string,
            cell: {
                lo: string,
                hi: string,
            },
        }
        deletePopupContentQuestion1: string,
        deletePopupContentQuestion2: string,
        deletePopup: {
            title: string,
            confirm: string,
            cancel: string,
        }
    };
    isHaccpLocation?: boolean;
    locationHaccpSingleElements: HaccpLocationSingleElement[];
    equipment?: any;
    hasHaccpConfigs?: boolean;
}

export interface HaccpTableState {
    extremesVisibility: boolean;
}

export class HaccpTable extends React.Component<HaccpTableProps, HaccpTableState> {

    private static hoursHeader = (length) => {
        const th = [];
        for (let h = 0; h < length; h++) {
            th.push(<th className={"hrs-col" + (!((h + 1) % 24) ? " last-hour-col" : "")}>{h % 24}:00</th>);
        }
        return th;
    }

    private static dateHeaders = (start: Date, length: number) => {
        const th = [];
        for (let day = 0; day < length; day += 1) {
            th.push((
                <th
                    className={"date-col"}
                    colSpan={24}
                    style={{
                        textAlign: "center",
                    }}
                >
                    {
                        moment(start)
                            .startOf(DEFAULT_TIME_UNIT)
                            .add(day, DEFAULT_TIME_UNIT)
                            .format(I18n.getLocaleDateFormat(LOCALE).toUpperCase())
                            .toString()
                    }
                </th>
            ));
        }
        return th;
    }

    private subscription: Subscription;

    constructor(props) {
        super(props);

        this.state = {
            extremesVisibility: this.props.controller.getExtremesVisibility(),
        };
    }

    public componentDidMount() {
        this.subscription = this.props.controller.listenToExtremesVisibility((visibility) => {
            this.setState({
                extremesVisibility: visibility,
            });
        });
    }

    public render() {
        return (
            <div
                className={"HaccpTable"}
                style={{
                    overflow: "auto",
                    width: "100%",
                    height: "100%",
                }}
            >
                <table
                    className={"config"}
                    style={{
                        zIndex: 6,
                        position: "sticky",
                        left: 0,
                        height: "inherit",
                        width: "100%",
                        overflow: "auto",
                        tableLayout: "fixed",
                        borderSpacing: "revert",
                    }}
                >
                    <thead
                        style={{
                            width: this.props.hasHaccpConfigs ? null : "100%",
                            display: this.props.hasHaccpConfigs ? null : "inline-table",
                        }}
                    >
                    {this.props.hasHaccpConfigs ? (<tr
                        style={{
                            border: "none",
                            height: 36,
                            zIndex: 7,
                            top: 0,
                        }}
                    >
                        <th
                            style={{
                                position: "sticky",
                                left: 0,
                                zIndex: 7,
                                top: 0,
                            }}
                            colSpan={this.state.extremesVisibility && this.props.hasHaccpConfigs ? 4 : 3}
                        />
                        {HaccpTable.dateHeaders(
                            this.props.controller.getDateRange().start,
                            this.props.hasHaccpConfigs
                                ? numberOfDays(
                                this.props.controller.getDateRange().end,
                                this.props.controller.getDateRange().start,
                                )
                                : 1,
                        )}
                    </tr>) : (<tr style={{border: "none", height: "36px", zIndex: 7, top: "0px"}}>
                        <th colSpan={3} style={{height: "36px", position: "sticky", left: "0px", zIndex: 7}}/>
                    </tr>)}
                    <tr
                        style={{
                            height: 36,
                            zIndex: 7,
                            top: "36px",
                        }}
                    >
                        <th
                            className={"name-col"}
                            style={{
                                position: "sticky",
                                left: 0,
                                zIndex: 7,
                                top: this.props.hasHaccpConfigs ? "33px" : "0",
                                width: this.props.hasHaccpConfigs ? null : "350px",
                            }}
                        >
                            {this.props.texts.diagnostics}
                        </th>
                        <th
                            className={"lo-col"}
                            style={{
                                width: this.props.hasHaccpConfigs ? null : "50px",
                                position: "sticky",
                                left: 350,
                                zIndex: 7,
                                top: this.props.hasHaccpConfigs ? "36px" : "0",
                                borderRight: this.props.hasHaccpConfigs ? null : "2px solid white",
                            }}
                        >
                            {this.props.texts.low}
                        </th>
                        <th
                            className={"hi-col"}
                            style={{
                                width: this.props.hasHaccpConfigs ? null : "50px",
                                position: "sticky",
                                left: 400,
                                zIndex: 7,
                                top: this.props.hasHaccpConfigs ? "36px" : "0",
                                borderRight: (this.props.hasHaccpConfigs) ? null : "2px solid gainsboro",
                                boxShadow: (this.props.hasHaccpConfigs) ? null : "6px 0px 6px 0px rgb(0 0 0 / 7%)",
                            }}
                        >
                            {this.props.texts.high}
                        </th>
                        {
                            !this.props.hasHaccpConfigs
                            ? (
                                <th
                                    className=""
                                    style={{
                                        position: "sticky",
                                        zIndex: 7,
                                        top: this.props.hasHaccpConfigs ? "33px" : "0",
                                    }}
                                />
                                )
                                : null
                        }
                        {this.state.extremesVisibility && this.props.hasHaccpConfigs
                            ? <th
                                className={"def-col"}
                                style={{
                                    background: "white",
                                    zIndex: 7,
                                    top: "33px",
                                }}
                            />
                            : null
                        }
                        {(this.props.hasHaccpConfigs)
                            ? HaccpTable.hoursHeader(this.props.hasHaccpConfigs
                            ? numberOfDays(
                            this.props.controller.getDateRange().end,
                            this.props.controller.getDateRange().start,
                            ) * 24
                            : 24,
                        )
                        : null
                        }
                    </tr>
                    </thead>
                    <tbody
                        style={!this.props.hasHaccpConfigs
                            ? {
                                width: "100%",
                                display: "inline-table",
                        }
                        : {}
                        }
                    >{(this.props.isHaccpLocation)
                        ? (this.props.locationHaccpSingleElements.map((haccpLocationSingleElement, index) => {
                            return ([HaccpEquipmentRow.renderEquipmentRow(
                                haccpLocationSingleElement.equipment,
                                this.props.controller.downloadAllReportExcel,
                                this.state.extremesVisibility && this.props.hasHaccpConfigs,
                                index,
                                haccpLocationSingleElement.configured.length !== 0,
                                !this.props.hasHaccpConfigs,
                            ),
                                this.renderSingleEquipment(haccpLocationSingleElement)]);
                        })) :
                        ([
                            (<tr
                                className="HaccpTableRow"
                                style={{
                                     height: "50px",
                                     outline: null,
                                }}
                            >
                                <td
                                    className="sticky-td"
                                    style={{
                                        height: "50px",
                                        width: this.props.hasHaccpConfigs ? null : "350px",
                                    }}
                                >
                                    <div className="cell-content-wrapper">
                                        <div className="vertical-align">
                                            <div className="vertical-align"/>
                                        </div>
                                    </div>
                                </td>
                                <td
                                    className="lo-col"
                                    style={{
                                        height: "50px",
                                        borderRight: "none",
                                        width: this.props.hasHaccpConfigs ? null : "50px",
                                    }}
                                >
                                    <div className="cell-content-wrapper" style={{borderRight: "none"}}>
                                        <div className="vertical-align"/>
                                    </div>
                                </td>
                                <td
                                    className="hi-col"
                                    style={{
                                        height: "50px",
                                        width: this.props.hasHaccpConfigs ? null : "50px",
                                }}
                                >
                                    <div
                                        className="cell-content-wrapper"
                                        style={{
                                            borderRight: this.state.extremesVisibility
                                                ? "2px solid white"
                                                : "2px solid gainsboro",
                                            boxShadow: (this.props.hasHaccpConfigs)
                                                ? "6px 0px 6px 0px rgb(0 0 0 / 7%)"
                                                : "6px 0px 6px 0px rgb(0 0 0 / 7%)",
                                        }}
                                    >
                                        <div className="vertical-align"/>
                                    </div>
                                </td>
                                {
                                    !this.props.hasHaccpConfigs
                                    ? (<td className="" style={{height: "50px"}}>
                                            <div
                                                className="cell-content-wrapper"
                                                style={{}}
                                            >
                                                <div className="vertical-align"/>
                                            </div>
                                        </td>) : null
                                }
                                {
                                    this.state.extremesVisibility
                                        ? (<td
                                            className="hi-col"
                                            style={{
                                                height: "50px",
                                                left: "450px",
                                                width: this.props.hasHaccpConfigs ? null : "50px",
                                            }}
                                        >
                                            <div
                                                className="cell-content-wrapper"
                                                style={{
                                                    borderRight: "2px solid gainsboro",
                                                    boxShadow: "6px 0px 6px 0px rgb(0 0 0 / 7%)",
                                                }}
                                            >
                                                <div className="vertical-align"/>
                                            </div>
                                        </td>)
                                        : null
                                }
                            </tr>),
                            this.renderSingleEquipment({
                            unconfigured: this.props.notConfigured,
                            configured: this.props.configuration,
                            equipment: undefined,
                            installationDate: undefined,
                        }),
                        ])}
                    </tbody>
                </table>
            </div>
        );
    }

    public componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    private exportExcel = (diagnosticGUID, equipmentGuid?) => () => {
        this.props.controller.downloadReportExcel(diagnosticGUID, equipmentGuid)
            .catch(console.error);
    }

    private openConfirmationDialog = ({guid, name}, equipmentGuid?) => {
        return () => {
            const onCancel = () => HaccpPagePopupController.closePopup();
            const onConfirm = (equipmentGUID) => () => {
                if (equipmentGUID) {
                    this.props.controller.equipmentGUID = equipmentGUID;
                }

                this.props.controller.deleteHaccpConfiguration(guid)
                    .then(() => {
                        HaccpPagePopupController.closePopup();
                    })
                    .catch(() => HaccpPagePopupController.closePopup());
            };

            const startContentText = this.props.texts.deletePopupContentQuestion2;
            const endContentText = this.props.texts.deletePopupContentQuestion1;

            HaccpPagePopupController.showPopup((
                <ConfirmationPopup
                    texts={{
                        ...this.props.texts.deletePopup,
                        content: startContentText + " " + name + " " + endContentText,
                    }}
                    onCancel={onCancel}
                    onConfirm={onConfirm(equipmentGuid)}
                    haccpController={this.props.controller}
                    equipmentGuid={equipmentGuid}
                />
            ));
        };
    }

    private openConfigurationPopup = (
        title: string,
        action: PopupAction,
        {name, guid, productCategory, modelGuid}: ConfigurationPopupInitData,
        equipmentGuid?: string,
    ) => {
        return () => {
            HaccpService.getEquipmentModelContentType(modelGuid, DEFAULT_TEMPERATURE_UNIT)
                .then((result) => {
                    return result.list as PossibleContent[];
                })
                .then((possibleContents) => {
                    possibleContents.forEach((pc) => {
                        pc.maxTemperature = ceilFixed(pc.maxTemperature, 1);
                        pc.minTemperature = ceilFixed(pc.minTemperature, 1);
                    });
                    return possibleContents.length > 0
                        ? possibleContents
                        : [
                            {
                                guid: DEFAULT_OTHER_PRODUCT_CATEGORY_GUID,
                                name: null,
                                minTemperature: 0,
                                maxTemperature: 1,
                            },
                        ];
                })
                .then((possibleContents) => {
                    const onConfigure = ({
                        [PopupAction.CREATE]: (result: PossibleContent) => {
                            this.props.controller.createNewHaccpConfiguration(guid, result)
                                .then(() => {
                                    HaccpPagePopupController.closePopup();
                                })
                                .catch(() => HaccpPagePopupController.closePopup());
                        },
                        [PopupAction.EDIT]: (result: PossibleContent) => {
                            this.props.controller.editHaccpConfiguration(guid, result)
                                .then(() => {
                                    HaccpPagePopupController.closePopup();
                                })
                                .catch(() => HaccpPagePopupController.closePopup());
                        },
                    })[action];

                    const onCancel = () => HaccpPagePopupController.closePopup();
                    HaccpPagePopupController.showPopup((
                        <ConfigurationPopup
                            texts={{
                                ...this.props.texts.configurationPopup,
                                title,
                                content: (action === PopupAction.EDIT
                                        ? this.props.texts.editPopupContent + " " + name
                                        : this.props.texts.createPopupContent + " " + name
                                ),
                                confirmButtonText: action === PopupAction.EDIT
                                    ? this.props.texts.editConfirmationButton
                                    : this.props.texts.createConfirmationButton,
                                warning: this.props.texts.configurationPopup.warning,
                            }}
                            onConfigure={onConfigure}
                            onCancel={onCancel}
                            possibleContents={possibleContents}
                            defaultContent={productCategory}
                            showContentType={possibleContents[0].name !== null
                            }
                            haccpController={this.props.controller}
                            equipmentGUID={equipmentGuid}
                        />
                    ));
                });
        };
    }

    private renderSingleEquipment(equipment: HaccpLocationSingleElement) {
        return [
            this.renderConfiguredProbesSingleEquipment(equipment),
            this.renderUnconfiguredProbesSingleEquipment(equipment),
        ];
    }

    private renderConfiguredProbesSingleEquipment(equipment: HaccpLocationSingleElement) {
        return equipment.configured.map((
            {
                name,
                productCategory,
                minTemperature,
                maxTemperature,
                targetDiagnosticType,
                records,
            },
            index,
            ) => {
                return HaccpTableRow.renderConfig(
                    {
                        probeName: targetDiagnosticType.name,
                        content: productCategory.name,
                    },
                    minTemperature,
                    maxTemperature,
                    this.state.extremesVisibility && this.props.hasHaccpConfigs,
                    this.props.texts.row,
                    Haccp.preprocessRecords(records),
                    this.props.texts.row.cell,
                    this.openConfigurationPopup(
                        this.props.texts.editPopupTitle,
                        PopupAction.EDIT,
                        {
                            name: targetDiagnosticType.name,
                            guid: targetDiagnosticType.guid,
                            productCategory: {
                                ...productCategory,
                                maxTemperature: ceilFixed(maxTemperature, 1),
                                minTemperature: ceilFixed(minTemperature, 1),
                            },
                            modelGuid: this.props.isHaccpLocation
                                ? equipment.equipment.model.guid
                                : this.props.equipmentModel.guid,
                        },
                        (equipment.equipment) ? equipment.equipment.guid : undefined,
                    ),
                    this.exportExcel(targetDiagnosticType.guid,
                        (equipment.equipment) ? equipment.equipment.guid : undefined),
                    this.openConfirmationDialog(targetDiagnosticType,
                        (equipment.equipment) ? equipment.equipment.guid : undefined),
                    index + 1,
                    this.props.isHaccpLocation,
                );
            },
        );
    }

    private renderUnconfiguredProbesSingleEquipment(equipment: HaccpLocationSingleElement) {
        return equipment.unconfigured.map(({name, guid}, index) => {
            return HaccpTableRow.renderNotConfig(
                name,
                this.state.extremesVisibility && this.props.hasHaccpConfigs,
                this.openConfigurationPopup(
                    this.props.texts.createPopupTitle,
                    PopupAction.CREATE,
                    {
                        name,
                        guid,
                        modelGuid: this.props.isHaccpLocation
                            ? equipment.equipment.model.guid
                            : this.props.equipmentModel.guid,
                    },
                    (equipment.equipment) ? equipment.equipment.guid : undefined,
                ),
                index,
                this.props.isHaccpLocation,
                this.props.hasHaccpConfigs,
            );
        });
    }
}
